import React, { useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { storage } from "../../../../Firebase/config";
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import html2canvas from "html2canvas"; // Ensure html2canvas is properly imported
import PopupContractPrivacyPolicy from "../../../Common/PopupContractPrivacyPolicy";
import { Modal } from "reactstrap";
import { useRouteBaseStateContext } from "../../../../Context/RouteBaseStateContext";
import { bxpRequest } from "../../../../redux/ots/action";
import { insertRequestinProduct, saleAcceptReject, saleRequest } from "../../../../redux/sale/action";
import { takeAndUploadScreenshot } from "../../../../utils/takeAndUploadScreenshot";
import SignContractInput from "../../SignContractInput";

const SignSaleContract = ({ pbi }) => {
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const laung = localStorage.getItem("laung");
  const [lan, setLan] = useState(laung ?? "en");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const { state } = location;
  const [modal, setModal] = useState(false);

  const profile = useSelector(({ profile: { profiledata } }) => profiledata);

  const formik = useFormik({
    initialValues: {
      first_name: profile?.first_name,
      last_name: profile?.last_name,
      agree: false,
    },
    validationSchema: Yup.object({
      first_name: Yup.string().required("First name is required"),
      last_name: Yup.string().required("Last name is required"),
      agree: Yup.boolean().oneOf([true], "You must agree to the terms"),
    }),
    onSubmit: async (values) => {
      try {
        setLoading(true);
        const screenshotUrl = await takeAndUploadScreenshot();

        if (screenshotUrl) {
          hireexpert(screenshotUrl, values);
        } else {
          setLoading(false);
          console.error("Failed to upload screenshot. Please try again.");
        }
      } catch (error) {
        console.error("Error taking or uploading screenshot:", error);
        setLoading(false);
      }
    },
  });


  const hireexpert = (screenshotUrl, values) => {
    if (state?.approvefrom == "buyer") {
      const state = {
        id: pbi?.id,
        sale_id: id,
        type: 3,
        type_of_post: "sale",
        post_id: pbi?.id,
        post_price: pbi?.price,
      };

      const data = {
        ...values,
        "sale_request_id": pbi?.id,
        "type": "2",
        image: screenshotUrl,
        url: `/${lan}/account/paymentmethodpage`,
        state: state,
      };
      dispatch(saleRequest(data, setLoading, navigate))
    }
    else if (state?.approvefrom == "buyerfromlist") {
      const data = {
        ...values,
        ...state?.payload,
        image: screenshotUrl,
      };
      dispatch(insertRequestinProduct(data, id));
      navigate(-1)
      setLoading(false)
    }
    else if (state?.approvefrom == "seller") {
      const data = {
        type: "1",
        sale_request_id: id,
        status: 3,
      };
      dispatch(saleAcceptReject(data));
      navigate(-1)
    } else {
      const state = {
        id: pbi?.id,
        type: 3,
        type_of_post: "packagedservices",
        post_id: pbi?.post_id,
        post_price: pbi?.first_amount,
      };

      const data = {
        ...values,
        type: "1",
        id: pbi?.id,
        image: screenshotUrl,
        url: `/${lan}/account/paymentmethodpage`,
        state: state,
        status: "25",
        "bxp_id": id,
        postdata: pbi
      };

      dispatch(bxpRequest(data, setLoading, navigate))
    }
  };

  const DeclineContract = () => {
    if (state?.approvefrom == "seller" || state?.approvefrom == "buyerfromlist") {
      navigate(-1)
    } else if (state?.owner) {
      const data = {
        type: "5",
        sale_request_id: id,
        status: 2,
      };
      dispatch(saleAcceptReject(data));
      navigate(-1)
    } else {
      const data = {
        type: "5",
        sale_request_id: id,
        status: 2,
      };
      dispatch(saleAcceptReject(data));
      navigate(-1)
    }
  };
  return (
    <>
      <form onSubmit={formik.handleSubmit}>
        {/* {JSON.stringify(state)} */}
        <SignContractInput formik={formik} />

        <div className="checkbox">
          <input
            type="checkbox"
            id="agree"
            name="agree"
            checked={formik.values.agree}
            onClick={() => {
              if (!formik.values.agree) {
                setModal(true);
              }
              else {
                formik.setFieldValue("agree", !formik.values.agree);
              }
            }}
          />
          <label htmlFor="agree">
            Yes, I understand and agree to Urxprt’s {' '}
            <span>{' '} Terms of Service</span>, including the
            <span>{' '} User Agreement</span> and <span>Privacy Policy</span>.
          </label>
          {formik.touched.agree && formik.errors.agree ? (
            <div className="error">{formik.errors.agree}</div>
          ) : null}
        </div>

        <div className="submit-btn">
          <button
            type="button"
            onClick={() => DeclineContract()}
            className="btn"
          >
            {(state?.approvefrom == "seller" || state?.approvefrom == "buyerfromlist") ? "Back" : "Decline contract"}
          </button>
          <button type="submit" className="btn post-btn" disabled={loading}>
            {loading
              ? "Submitting..."
              : state?.approvefrom == "user"
                ? "Accept & Start project"
                : "Accept"}
          </button>
        </div>
      </form>
      {modal && (
        <Modal
          isOpen={modal}
          keyboard={false}
          className="modal-width modal-centered popupmodal termsconditionmodal"
        >
          <PopupContractPrivacyPolicy formik={formik} setModal={setModal} />
        </Modal>
      )}
    </>
  );
};

export default SignSaleContract;
